"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Items = void 0;
const types_1 = require("@air/types");
const clips_1 = require("./clips");
const request_1 = require("./request");
// defaults are different from the ones for normal board list
const boardListDefaults = {
    isMemberOfBoard: 'ALL',
    numThumbnails: 1,
    includeAncestors: true,
    includeDirectDescendantCount: false,
};
const defaultListOptions = Object.assign(Object.assign({}, boardListDefaults), { type: clips_1.Clips.CLIP_LIST_DEFAULTS.type, limit: 100, view: 'all', withOpenDiscussionStatus: true });
/**
 * Moves boards and/or clips from a given source to a new parent board.
 * This API requires all items are coming from the same source (same board for all clipIds)
 *
 * @param workspaceId workspaceId of the parent to move items to
 * @param targetBoardId boardId of the parent to move items to
 * @param items the items to move
 * @param [libraryId] Id of library to move boards into
 *                    This parameter is really only required when targetBoardId is null (moving to the top-level),
 *                    since there would be no wait to get library context since there is no targetBoardId.
 *                    If both targetBoardId and libraryId are specified, targetBoardId must be in the libraryId. */
function batchMove(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, targetBoardId, items, libraryId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.items, {
            endpoint: `move`,
            method: 'POST',
            body: {
                targetBoardId,
                libraryId,
                items,
            },
            workspaceId,
            boardContext: [
                ...(items.boardIds || []),
                ...('assetSourceBoardId' in items ? [items.assetSourceBoardId] : []),
                ...(targetBoardId ? [targetBoardId] : []),
            ],
        });
    });
}
function searchClipsAndBoards(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, options = {}, }) {
        const withDefaults = Object.assign(Object.assign({}, defaultListOptions), options);
        return (0, request_1.airRequest)(types_1.EndpointType.items, {
            endpoint: `searchClipsAndBoards`,
            method: 'POST',
            body: withDefaults,
            workspaceId,
        });
    });
}
/**
 * Search clips and boards and return a grouped search result
 *
 * @param workspaceId workspace id
 * @param options search options
 * @returns a grouped search response
 */
function searchClipsAndBoardsWithGrouping(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, options, }) {
        const withDefaults = Object.assign(Object.assign({}, defaultListOptions), options);
        return (0, request_1.airRequest)(types_1.EndpointType.items, {
            endpoint: `searchClipsAndBoardsWithGrouping`,
            method: 'POST',
            body: withDefaults,
            workspaceId,
        });
    });
}
/**
 * Moves board item(s) between 2 other items or before/after a specific item
 * @param idsToMove Item ids to move (in the order that they appear in gallery)
 * @param betweenIds.moveBeforeId Item id to move idsToMove before (end)
 * @param betweenIds.moveAfterId Item id to move idsToMove after (start)
 * @param cursor If moving board to end of page, optional cursor can be supplied to infer betweenIds.moveBeforeId
 * @param view If moving on a specific board view, either the board_view.id is provided or just the viewType
 */
function updateItemPositions(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.items, {
            endpoint: 'position',
            method: 'PATCH',
            body: rest,
            workspaceId,
            boardContext: rest.boardId,
        });
    });
}
exports.Items = {
    batchMove,
    searchClipsAndBoards,
    searchClipsAndBoardsWithGrouping,
    updateItemPositions,
    defaultListOptions,
};
//# sourceMappingURL=items.js.map